const CoronaMass = [
  {
    id: 1,
    title: 'Pina corona 350мл',
    price: '250 грн',
    src: require('../img/pinaCorona.png'),
    text: `ром білий,
сік ананасу, 
сироп  мигдалю, 
Фреш лайму,
корона`,
  },
  {
    id: 2,
    title: 'Corona paloma 350мл',
    price: '250 грн',
    src: require('../img/Coronapaloma.png'),
    text: `Текіла,
сік грейпфрута,
 Кампари, 
Цукровий сироп,
Фреш лайму, 
Корона`,
  },
  {
    id: 3,
    title: 'Corona verde 350мл',
    price: '250 грн',
    src: require('../img/Coronaverde.png'),
    text: `Білий ром, 
сироп агави,
Фреш лайму, 
Мята, 
корона`,
  },
  {
    id: 4,
    title: 'Corona passion 350мл',
    price: '250 грн',
    src: require('../img/Coronapassion.png'),
    text: `ром Д’Арк, 
сироп маракуя, 
Цукровий сироп, 
Фреш лайму,
корона`,
  },


  // {
  //     id:1,
  //     title:"Корона санрайз",
  //     price:"160 грн",
  //     src: require('../img/corona2.png'),
  //     text:"корона, текіла, сироп гренадін, апельсиновий сік, лайм",
  // },
  // {
  //     id:2,
  //     title:"Лікар Корона",
  //     price:"160 грн",
  //     src: require('../img/corona4.png'),
  //     text:"корона, капітан морган голд, лікер амарето, лайм",
  // },
  // {
  //     id:3,
  //     title:"Корона по пляжу",
  //     price:"160 грн",
  //     src: require('../img/corona3.png'),
  //     text:"корона, капітан морган голд, лікер грін мелон, лайм",
  // },
  // {
  //     id:4,
  //     title:"Аватар корона",
  //     price:"160 грн",
  //     src: require('../img/corona1.png'),
  //     text:"корона, капітан морган голд, лікер блю курасао, лайм",
  // },
  // {
  //     id:5,
  //     title:"Корона з оленем",
  //     price:"160 грн",
  //     src: require('../img/corona4.png'),
  //     text:"корона, лимонний сік, Jägermeister, лайм",
  // },
];

export default CoronaMass;
